module.exports = __webpack_public_path__ + "static/media/calendar-blue.611e6a59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/calendar-blue.svg
// module id = 159
// module chunks = 1